import React, { useState } from 'react';
import { getFrontendVersion } from '../../model/version';
import { Banner } from '../Banner/Banner';
import { Button } from '../Button/Button';
import { t } from '../../locales/translate';
import { useSequentialPolling } from '../../model/data';

export function BuildCheck(): JSX.Element {
  const [displayUpdate, setDisplayUpdate] = useState(false);

  async function checkFrontendVersion(): Promise<void> {
    const { outdated } = await getFrontendVersion();

    if (outdated && !displayUpdate) {
      setDisplayUpdate(true);
    }
  }

  useSequentialPolling({
    load: checkFrontendVersion,
    interval: 600,
    start: true,
  });

  function handleOnSubmit(): void {
    window.location.reload();
  }

  return (
    <Banner
      open={displayUpdate}
      onClose={() => setDisplayUpdate(false)}
      title={t.component.buildCheck.outdatedVersionTitle}
      footer={<Button title={t.component.buildCheck.outdatedVersionButton} type="primary" onClick={handleOnSubmit} />}
    >
      <p>{t.component.buildCheck.outdatedVersionDescription}</p>
    </Banner>
  );
}
